// Move existing nodes only: preserve every character, ruby annotation and link.
export default function formatBibleReading(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('em').forEach((marker) => {
    if (!/^\d+:\d+$/.test(marker.textContent.trim())) return;
    const block = doc.createElement('div');
    block.className = 'bible-reading-verse';
    marker.before(block);
    block.appendChild(marker);
    // Some ruby books have bare text/ruby nodes, others have verse spans.
    while (block.nextSibling) {
      const next = block.nextSibling;
      if (next.nodeType === 1 &&
          (!next.matches('span, ruby, br, a, b, i, strong, small, sup, sub') || next.querySelector('em'))) break;
      block.appendChild(block.nextSibling);
    }
  });
  return doc.body.innerHTML;
}
